// extracted by mini-css-extract-plugin
export default {"container":"EventDetails_container__paKfd","details":"EventDetails_details__yu1Rj","members":"EventDetails_members__a-UyW","buttons":"EventDetails_buttons__vExLL"};